import React from "react";

export default function Welcome() {
  return (
    <div>
      <div className=" w-[98%] mx-auto mt-0 pt-4 pb-2 ">
        <h2 className="text-3xl text-green-700">Wealth Management</h2>
        <p className="text-3xl text-green-700 pt-2">
          made easy with Eagle Assets & Resource Management.
        </p>
      </div>
      <div className="container mx-auto text-justify p-2">

      </div>
    </div>
  );
}
